export default {"src":"/_next/static/media/add-circle-outline.aaf3d44f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};